class Accordion extends HTMLElement {
    constructor() {
        super();

        this.el = this;

        this.detailsContainer = this.querySelector('details');
        this.summaryToggle = this.querySelector('summary');
        // Store the .accordion__content element
        this.content = this.querySelector('.accordion__content');

        this.detailsContainer.addEventListener(
            'keyup',
            (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
        );
        this.summaryToggle.addEventListener(
            'click',
            this.onSummaryClick.bind(this)
        );

        this.summaryToggle.setAttribute('role', 'button');

        // Store the animation object (so we can cancel it if needed)
        this.animation = null;
        // Store if the element is closing
        this.isClosing = false;
        // Store if the element is expanding
        this.isExpanding = false;
    }

    onSummaryClick(e) {
        // Stop default behaviour from the browser
        e.preventDefault();
        // Add an overflow on the <details> to avoid content overflowing
        this.el.style.overflow = 'hidden';
        // Check if the element is being closed or is already closed
        if (this.isClosing || !this.detailsContainer.open) {
            this.open.call(this);
            // Check if the element is being openned or is already open
        } else if (this.isExpanding || this.detailsContainer.open) {
            this.close.call(this);
        }
    }

    open() {
        // Apply a fixed height on the element
        this.el.style.height = `${this.el.offsetHeight}px`;
        // Force the [open] attribute on the details element
        this.detailsContainer.open = true;
        // Wait for the next frame to call the expand function
        window.requestAnimationFrame(this.expand.bind(this));
    }

    close() {
        // Set the element as "being closed"
        this.isClosing = true;

        // Store the current height of the element
        const startHeight = `${this.content.offsetHeight}px`;
        // Calculate the height of the summary
        const endHeight = "0px";
        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.content.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight]
        }, {
            duration: 250,
            easing: 'ease-out'
        });

        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(false);
        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = () => this.isClosing = false;
    }

    expand() {
        // Set the element as "being expanding"
        this.isExpanding = true;
        // Get the current fixed height of the element
        const startHeight = "0px";//`${this.summaryToggle.offsetHeight}px`;
        // Calculate the open height of the element (summary height + content height)
        const endHeight = `${this.content.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }
        // Start a WAAPI animation
        this.animation = this.content.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight]
        }, {
            duration: 250,
            easing: 'ease-out'
        });
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(true);
        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
        // Set the open attribute based on the parameter
        this.detailsContainer.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.isClosing = false;
        this.isExpanding = false;
        // Remove the overflow hidden and the fixed height
        this.el.style.height = this.el.style.overflow = '';
    }
}
if (!customElements.get('accordion-tabs')) customElements.define('accordion-tabs', Accordion);